import { render, staticRenderFns } from "./CheckboxesListModal.vue?vue&type=template&id=7f8445bb&scoped=true&"
import script from "./CheckboxesListModal.vue?vue&type=script&lang=js&"
export * from "./CheckboxesListModal.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxesListModal.vue?vue&type=style&index=0&id=7f8445bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8445bb",
  null
  
)

export default component.exports